module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shared":{"home":"Home","links":"Links","contact":"Contact","imprint":"Imprint","privacy-policy":"Privacy Policy"}},"de":{"shared":{"home":"Startseite","links":"Links","contact":"Kontakt","imprint":"Impressum","privacy-policy":"Datenschutz"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./src/assets/locales/shared.json
// module id = 4OMQ
// module chunks = 0